import React from "react";
import { CareReceiverLocationFieldView } from "./view";
import { styles } from "./styles";

export const CareReceiverLocationField = props => (
  <CareReceiverLocationFieldView {...props} styles={styles} />
);
